<template>
	<div class="position-relative pb-3">
    <div class="cd-card mt-2">
      <div class="cd-accent-strip"></div>

      <!-- Hotel header -->
      <div class="px-3 pt-3 pb-3 d-flex align-items-center">
        <img :src="data.merchant.image_url" class="cd-logo rounded-12 object-fit flex-shrink-0 mr-3">
        <div class="min-w-0 flex-grow-1">
          <p class="mb-1 cd-hotel-name text-truncate">{{data.merchant.name}}</p>
          <template v-if="show_room">
            <span class="cd-room-badge" :class="{'cd-room-badge-danger': data.room_type == 'Unallocated Room Type'}">
              {{ data.room_type }}
            </span>
          </template>
          <template v-else>
            <p class="mb-0 cd-date-range">{{formatDate(data.detail.check_in)}} → {{formatDate(data.detail.check_out)}}</p>
            <p class="mb-0 cd-room-count">{{data.total_rooms}} Room{{data.total_rooms > 1 ? 's' : ''}}</p>
          </template>
        </div>
      </div>

      <!-- Toggle -->
      <div class="cd-toggle px-3 py-2 cursor-pointer" @click="is_detail = !is_detail">
        <div class="d-flex align-items-center justify-content-between">
          <p class="mb-0 cd-toggle-label">{{$t('hotel.concierge.reservation-detail')}}</p>
          <i class="simple-icon-arrow-down cd-chevron" :class="{'cd-chevron-open': is_detail}"></i>
        </div>
      </div>

      <!-- Detail zone -->
      <div v-if="is_detail">
        <!-- Reservation section -->
        <div class="cd-section px-3 pt-3 pb-3">
          <p class="cd-label mb-3">{{$t('hotel.concierge.reservation-detail')}}</p>
          <div class="row">
            <div class="col-6 mb-3">
              <p class="mb-1 cd-field-label">{{$t('hotel.concierge.checkin')}}</p>
              <p class="mb-0 cd-field-value">{{formatDate(data.detail.check_in)}}</p>
            </div>
            <div class="col-6 mb-3">
              <p class="mb-1 cd-field-label">{{$t('hotel.concierge.checkout')}}</p>
              <p class="mb-0 cd-field-value">{{formatDate(data.detail.check_out)}}</p>
            </div>
            <div class="col-6 mb-3">
              <p class="mb-1 cd-field-label">{{$t('hotel.concierge.total-nights')}}</p>
              <p class="mb-0 cd-field-value">{{totalNights}} {{$t('hotel.night')}}</p>
            </div>
            <div class="col-6 mb-3">
              <p class="mb-1 cd-field-label">{{$t('hotel.room-type.room-type')}}</p>
              <p class="mb-0 cd-field-value">{{data.room_type}}</p>
            </div>
            <div class="col-6 mb-3">
              <p class="mb-1 cd-field-label">{{$t('hotel.room')}}</p>
              <p class="mb-0 cd-field-value">{{data.room}}</p>
            </div>
            <div class="col-6 mb-3" v-if="isRateShown">
              <p class="mb-1 cd-field-label">{{$t('hotel.rate')}}</p>
              <p class="mb-0 cd-field-value">{{data.rate}}</p>
            </div>
            <div class="col-6 mb-0">
              <p class="mb-1 cd-field-label">{{$t('hotel.concierge.guest')}}</p>
              <p class="mb-0 cd-field-value">{{guest}}</p>
            </div>
          </div>
        </div>

        <!-- Contact section -->
        <div class="cd-section px-3 pt-3 pb-3">
          <p class="cd-label mb-3">{{$t('hotel.concierge.contact-details')}}</p>
          <div class="row">
            <div class="col-12 mb-3">
              <p class="mb-1 cd-field-label">Full Name</p>
              <p class="mb-0 cd-field-value">{{`${data.guest.prefix_name ? data.guest.prefix_name : ''} ${data.guest.name}`}}</p>
            </div>
            <div class="col-6 mb-3">
              <p class="mb-1 cd-field-label">{{$t('hotel.concierge.form.email')}}</p>
              <p class="mb-0 cd-field-value text-truncate">{{data.guest.email == null ? '-' : data.guest.email}}</p>
            </div>
            <div class="col-6 mb-0">
              <p class="mb-1 cd-field-label">{{$t('hotel.concierge.form.phone-number')}}</p>
              <p class="mb-0 cd-field-value">{{data.guest.phone == null ? '-' : data.guest.phone}}</p>
            </div>
          </div>
        </div>

        <!-- Special request section -->
        <div class="cd-section px-3 pt-3 pb-3">
          <p class="cd-label mb-3">{{$t('hotel.concierge.special-request')}}</p>
          <p class="mb-0 cd-field-value cd-special-request" v-html="data.detail.special_request || '—'"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {formatDate} from '@/utils/index.js'
  import { mapGetters } from 'vuex';

	export default{
		props: ['data','show_room'],
		data(){
			return{
				is_detail: false
			}
		},
    computed:{
      ...mapGetters(['getMerchant']),
      totalNights(){
        const checkIn = new Date(this.data.detail.check_in);
        const checkOut = new Date(this.data.detail.check_out);
        return Math.round((checkOut - checkIn) / (1000 * 60 * 60 * 24));
      },
      guest(){
        let display= `${this.data.detail.adult} ${this.$t('hotel.concierge.adult')}`
        if(this.data.detail.child > 0){
          display += (`, ${this.data.detail.child} ${this.$t('hotel.concierge.child')}`)
        }
        return display;
      },
      isRateShown(){
        return !!this.data.rate && !!this.getMerchant.precheckin_form_header_show_rate;
      }
    },
    methods:{
      formatDate(date){
        return formatDate(date);
      }
    }
	}
</script>
<style scoped>
.cd-card {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #E8EEF3;
  box-shadow: 0 1px 2px rgba(15,30,50,0.04), 0 4px 14px rgba(15,30,50,0.06);
  overflow: hidden;
}

.cd-accent-strip {
  height: 4px;
  background: var(--merchant-primary-color, #2d8c6e);
}

.cd-logo {
  width: 56px;
  height: 56px;
  object-fit: cover;
}

.cd-hotel-name {
  font-size: 16px;
  font-family: Nunito-Bold;
  color: #1C2B36;
  margin-bottom: 4px;
  line-height: 1.3;
}

.cd-room-badge {
  display: inline-block;
  font-size: 11px;
  font-family: Nunito-Bold;
  padding: 3px 10px;
  border-radius: 20px;
  background: var(--merchant-primary-color-alpha-15, rgba(45,140,110,0.12));
  color: var(--merchant-primary-color, #2d8c6e);
  letter-spacing: 0.018em;
}

.cd-room-badge-danger {
  background: rgba(192, 64, 64, 0.1);
  color: #C04040;
}

.cd-date-range {
  font-size: 12px;
  font-family: Nunito-SemiBold;
  color: #3A4A56;
  margin-bottom: 4px;
}

.cd-room-count {
  font-size: 12px;
  font-family: Nunito-Regular;
  color: #888EA0;
}

.cd-toggle {
  border-top: 1px solid #E8EEF3;
  background: #FAFAFC;
  transition: background 0.15s ease;
}

.cd-toggle:hover {
  background: #F3F4F7;
}

.cd-toggle-label {
  font-size: 12px;
  font-family: Nunito-SemiBold;
  color: var(--merchant-primary-color, #2d8c6e);
  letter-spacing: 0.017em;
}

.cd-chevron {
  font-size: 11px;
  color: var(--merchant-primary-color, #2d8c6e);
  transition: transform 0.2s ease;
}

.cd-chevron-open {
  transform: rotate(180deg);
}

.cd-section {
  border-top: 1px solid #E8EEF3;
}

.cd-label {
  font-size: 12px;
  font-family: Nunito-Bold;
  color: #6B7886;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-bottom: 0;
}

.cd-field-label {
  font-size: 11px;
  font-family: Nunito-SemiBold;
  color: #A0AABA;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0;
}

.cd-field-value {
  font-size: 14px;
  font-family: Nunito-SemiBold;
  color: #1C2B36;
  line-height: 1.4;
}

.cd-special-request {
  font-family: Nunito-Regular;
  font-size: 13px;
  color: #3A4A56;
  line-height: 1.5;
}

@media screen and (min-width: 992px) {
  .cd-logo {
    width: 48px;
    height: 48px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/concierge/checkin/CheckinData.vue